import { render, staticRenderFns } from "./DialogImportantMessage.vue?vue&type=template&id=e6cae3aa&"
import script from "./DialogImportantMessage.vue?vue&type=script&lang=js&"
export * from "./DialogImportantMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports